import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./components/api";

const ProtectedRouteEmployee = ({ children, permission }) => {
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(true);
  const [hasRights, setHasRights] = useState(false);

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      const token = localStorage.getItem("access_token");

      if (!token) {
        //console.warn("No access token");
        navigate("/seller/staff_login");
        return;
      }

      if (!baseUrl) {
        //console.warn("Base URL is not defined");
        return;
      }

      try {
        const response = await api.get(`${baseUrl}/vendor-dashboard/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const rights = response.data.rr;
        //console.log("Rights array:", rights);

        if (rights === 0) {
          setHasRights(true);
        }else if (Array.isArray(rights) && rights.includes(permission)) {
            setHasRights(true);
          } else {
          setHasRights(false);
          navigate("/seller/dashboard");
        }
      } catch (err) {
        //console.error("Error checking permissions:", err);
        //navigate("/seller/dashboard");
      } finally {
        setLoading(false);
      }
    };

    fetchEmployeeDetails();
  }, [baseUrl, navigate, permission]);

  if (loading) return <p>Loading...</p>;

  return hasRights ? <>{children}</> : null;
};

export default ProtectedRouteEmployee;
